import React from 'react';
import styles from './RoomListCard.module.css';

/** Linhas de carregamento no formato das linhas de sala (ícone, nome e descrição, selo). */
function RoomListSkeleton({ rows = 3 }) {
    return (
        <ul className={styles.list} aria-busy="true" aria-label="Carregando salas">
            {Array.from({ length: rows }).map((_, index) => (
                <li key={index} className={styles.skeletonRow}>
                    <span className={`${styles.shimmer} ${styles.skeletonIcon}`} />
                    <span className={styles.skeletonText}>
                        <span className={`${styles.shimmer} ${styles.skeletonLine}`} style={{ width: `${50 - index * 8}%` }} />
                        <span className={`${styles.shimmer} ${styles.skeletonLineSm}`} />
                    </span>
                    <span className={`${styles.shimmer} ${styles.skeletonTag}`} />
                </li>
            ))}
        </ul>
    );
}

export default RoomListSkeleton;
